export default __webpack_public_path__ + "static/YarraYering_Vyard-cfbfc9baa10ae394db0c647b57410d41.jpg";